import {createSlice} from '@reduxjs/toolkit';
import {ActionType} from '../models/action-type';
import { FavoriteGetResponse } from '../models/api/front/favorite';

export type FavoriteSetItem = {
	id: string,
	name: string,
	type: 'folder' | 'set',
	level: number, // 階層（1~3）
	parentId: string,
	children: FavoriteSetItem[],
  favProductIds: string[],
};

type FavoriteSetSliceState = {
	setList: FavoriteSetItem[],
	selectSet: FavoriteSetItem | undefined,
	setDataList: FavoriteGetResponse[],
};

const initialState: FavoriteSetSliceState = {
	setList: [
    // {
    //   id: '0',
    //   name: 'ベーシック',
		// 	type: 'folder',
    //   children: [
    //     {
    //       id: '1',
    //       name: '注文ベース',
		// 			type: 'folder',
    //       children: [],
    //     },
    //     {
    //       id: '2',
    //       name: 'オプション付き注文ベース',
		// 			type: 'folder',
    //       children: [],
    //     }
    //   ],
    // },
    // {
    //   id: '3',
    //   name: 'アドバンス',
		// 	type: 'folder',
    //   children: [
    //     {
    //       id: '4',
    //       name: '更新',
		// 			type: 'folder',
    //       children: [
    //         {
    //           id: '5',
    //           name: 'サムネイル',
		// 					type: 'folder',
    //           children: [
    //             {
    //               id: '6',
    //               name: '01_サムネイル更新',
		// 							type: 'set',
    //               children: [],
    //             },
    //             {
    //               id: '7',
    //               name: '02_サムネイル更新リスト',
		// 							type: 'set',
    //               children: [],
    //             },
    //           ],
    //         },
    //       ],
    //     },
    //   ],
    // },
	],
	selectSet: undefined,
	setDataList: [],
};

const setFolder: ActionType<FavoriteSetSliceState, FavoriteSetItem[]> = (state, action) => {
	state.setList = action.payload;
};

const addFolder: ActionType<FavoriteSetSliceState, FavoriteSetItem> = (state, action) => {
	state.setList.push(action.payload);
};

const createChildrenArray = (
	searchRow: FavoriteSetItem,
	targetItem: FavoriteSetItem,
	isUpdate: boolean
) => {
	let rowChildren: FavoriteSetItem[] = [];
	const children: FavoriteSetItem[] = [];
	searchRow.children?.forEach((childNode) => {
		if (childNode.id !== targetItem.id && childNode.children && childNode.children.length > 0) {
			rowChildren.push(childNode as FavoriteSetItem);
			children.push(childNode);
			createChildrenArray(childNode, targetItem, isUpdate ? true : false);
		} else if (childNode.id !== targetItem.id && childNode.children && childNode.children.length === 0) {
			rowChildren.push(childNode as FavoriteSetItem);
			children.push(childNode);
		} else if (isUpdate) {
			childNode = Object.assign(childNode, targetItem);
			rowChildren.push(childNode as FavoriteSetItem);
			children.push(childNode);
		}
		searchRow.children = children;
	});
	return rowChildren;
};

const changeName: ActionType<FavoriteSetSliceState, FavoriteSetItem> = (state, action) => {
	const result: FavoriteSetItem[] = [];
	while (state.setList.length > 0) {
		let row = state.setList.shift();
		if (row?.children && row.children.length > 0 && row.id !== action.payload.id) {
			const rowChildren: FavoriteSetItem[] = createChildrenArray(row, action.payload, true);
			row.children = rowChildren;
			result.push(row);
		} else if (row?.children?.length === 0 && row.id !== action.payload.id) {
			result.push(row);
		} else {
			row = Object.assign(row, action.payload);
			result.push(row);
		}
	}
	state.setList = Object.assign(state.setList, result);
};

const deleteFolder: ActionType<FavoriteSetSliceState, FavoriteSetItem> = (state, action) => {
	const result: FavoriteSetItem[] = [];
	while (state.setList.length > 0) {
		const row = state.setList.shift();
		if(row?.children && row.children.length > 0 && row.id !== action.payload.id) {
			const rowChildren: FavoriteSetItem[] = createChildrenArray(row, action.payload, false);
			row.children = rowChildren;
			result.push(row);
		} else if (row?.children?.length === 0 && row.id !== action.payload.id) {
			result.push(row);
		}
	}
	state.setList = Object.assign(state.setList, result);
};

const setSelectSet: ActionType<FavoriteSetSliceState, FavoriteSetItem | undefined> = (state, action) => {
	state.selectSet = action.payload;
};

const setSetDataList: ActionType<FavoriteSetSliceState, FavoriteGetResponse[]> = (state, action) => {
	state.setDataList = action.payload;
};

const addSetDataList: ActionType<FavoriteSetSliceState, FavoriteGetResponse[]> = (state, action) => {
	state.setDataList = [...state.setDataList, ...action.payload];
}

export const favoriteSetSlice = createSlice({
  name: 'favorite-set',
  initialState,
  reducers: {
		setFolder,
		addFolder,
		changeName,
		deleteFolder,
		setSelectSet,
		setSetDataList,
		addSetDataList,
	},
});

export const favoriteSetActions = favoriteSetSlice.actions;
export const favoriteSetReducer = favoriteSetSlice.reducer;
